import { getPublicRuntimeConfig } from '~/cynqueModules/nuxtAccessors'
import { isUsingMockApi } from '~/cynqueModules/isUsingMockApi'

/**
 * Whether Service Requests are LIVE. Off, the list route shows its placeholder
 * (pages/Service Requests/index.vue -- the nav entry stays), the Overview and
 * Types routes redirect Home (middleware/serviceRequestsGate.ts), and the
 * Select Lists section and the footer '+' item are hidden.
 *
 * ⚠ The live API has NO Service Request endpoints yet. SR was forked from Cases
 * (`cases-pre-sr-fork`) to preserve the case functionality that is about to be
 * removed from Cases, and it runs against MSW only until the server side exists.
 * A route that works only against the mock is a 404 in production, so this is
 * OFF against a live API unless a deployment opts in.
 *
 * On whenever the mock API is, so dev and e2e always see SR. Otherwise
 * `runtimeConfig.public.serviceRequestsEnabled`, overridden per deployment AT
 * RUNTIME with NUXT_PUBLIC_SERVICE_REQUESTS_ENABLED=true -- the container image
 * is built once for every tenant, so this cannot be a build-time setting.
 */
export function isServiceRequestsEnabled(): boolean {
  if (isUsingMockApi()) {
    return true
  }
  // Nitro hands a runtime override over as the env var's STRING.
  const configured: unknown = getPublicRuntimeConfig().serviceRequestsEnabled
  return configured === true || configured === 'true'
}
